// extracted by mini-css-extract-plugin
module.exports = {"slider":"StyledSlider_slider__QRaw7"};